import React from 'react';
import WelcomePageInit from '../../components/student-password-reset-section/WelcomePageInitialization';

const WelcomePage = (props) => (
    <WelcomePageInit {...props} />
);

export default WelcomePage;